import { NgModule } from '@angular/core';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';

import { CommonModule } from '@angular/common';

import { RestInterpolatorService } from './rest-interpolator.service';
import { RestJsonCodecService } from './rest-json-codec.service';
import { RestActivityInterceptor } from './interceptors/rest-activity-interceptor';
import { RestSessionInterceptor } from './interceptors/rest-session-interceptor';
import { RestXsrfInterceptor } from './interceptors/rest-xsrf-interceptor';
import {
  RestErrorHandlerService,
  REST_ERROR_HANDLERS
} from './rest-error-handler.service';
import { RestSystemErrorHandlerService } from './rest-system-error-handler.service';

@NgModule({
  imports: [CommonModule], providers: [
    RestInterpolatorService,
    RestJsonCodecService,
    RestErrorHandlerService,
    { provide: HTTP_INTERCEPTORS, useClass: RestActivityInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: RestSessionInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: RestXsrfInterceptor, multi: true },
    { provide: REST_ERROR_HANDLERS, useClass: RestSystemErrorHandlerService, multi: true },
    provideHttpClient(withInterceptorsFromDi())
  ]
})
export class RestModule {
}
